const unregisterServiceWorkers = () => {
  if (navigator && navigator.serviceWorker) {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      if (!registrations.length) {
        return;
      }
      registrations.forEach((registration) => {
        registration.unregister();
      });
    });
  }
};

export default unregisterServiceWorkers;
